import { useUserContext } from '~/contexts/UserContext';
import { determineWeddingLocationFromUserContext } from '~/selectors/quizletSelectors';

export const useUserContextWeddingLocation = () => {
  const userContext = useUserContext();
  return determineWeddingLocationFromUserContext(userContext);
};
